import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-userSvg",
  "use": "icon-userSvg-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-userSvg\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>01icon/user</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-userSvg_Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-userSvg_01icon/user\">\n            <g id=\"icon-userSvg_icon_user\">\n                <rect id=\"icon-userSvg_Rectangle\" x=\"0\" y=\"0\" width=\"22\" height=\"22\" />\n                <path d=\"M19,19 L3,19 C3,14.582 6.582,11 11.001,11 C15.419,11 19,14.582 19,19 Z M7.001,7 C7.001,4.791 8.791,3 11.001,3 C13.21,3 15.001,4.791 15.001,7 C15.001,9.21 13.21,11 11.001,11 C8.791,11 7.001,9.21 7.001,7 Z\" id=\"icon-userSvg_path\" fill=\"#889AA4\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/userSvg.svg
// module id = HLoT
// module chunks = 54